import React from 'react';
import {DateField, type DateValue} from '@netx/core-components/DateField';
import type {CommonProps} from '../../types';
import {usePlaceholder} from '../../../../hooks';

export interface DateAttributeProps extends CommonProps<DateValue> {}

export const DateAttributePrimitive = ({
	action,
	attrData,
	hideLabel,
	isMetadataTarget,
	multipleValues,
	placeholder = '',
	value,
	// so it does no get passed along
	// only some of our attribute types are offer folksonomy
	disableFolksonomy,
	// only some of our attribute types are offer lookup
	isMetadataLookup,
	onLookup,
	// only some of our attribute types are searchable
	onSearch,
	...props
}: DateAttributeProps) => {
	const cleared = action === 'clear';
	const defaultValue = value != null ? value : null;
	const shrinkLabel = multipleValues || cleared;

	const textfieldPlaceholder = usePlaceholder(attrData, placeholder, {
		cleared,
		multipleValues,
		value: defaultValue,
	});

	return (
		<DateField
			fullWidth
			hideErrorMessage
			id={`${attrData.attributeid.toString()}`}
			label={hideLabel ? undefined : attrData.name}
			name={attrData.name}
			{...props}
			placeholder={textfieldPlaceholder}
			value={defaultValue}
			InputLabelProps={{
				shrink: shrinkLabel ? true : undefined,
			}}
		/>
	);
};

export const DateAttribute = React.memo(DateAttributePrimitive);

export default DateAttribute;
